// BasicInformation.js

import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Grid, TextField, MenuItem, Button , Typography } from "@mui/material";
import useStyles from "./style";
import { useDropzone } from "react-dropzone";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
//Datas
import countryCodeData from "./Data/CountryCode";

const BasicInformation = ({ onRef, formik, driverId , setsubmitButton , setSkipButton}) => {
  const classes = useStyles();
  const intl = useIntl();
  const t = intl.formatMessage;
  setsubmitButton(true);
  setSkipButton(true);
  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };
  // Dropzone props
  const { getRootProps, getInputProps, open, fileRejections } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: formatBytes(maxFileSize),
    maxFiles: 1,
    accept: "image/*",
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        const file = acceptedFiles[0];
      //console.log("typeof file-->", typeof(file));

        // Convert file to Base64
        const reader = new FileReader();
        reader.onload = () => {
          const base64String = reader.result;
          formik.setFieldValue("passengerProfileImagefileformat", file);
          formik.setFieldValue("passengerProfileImage", base64String); // Keep the file for form submission 
        };
        reader.onerror = (error) => {
          console.error("Error converting file to Base64:", error);
        };
        reader.readAsDataURL(file); // Convert file to Base64
      }
    },
  });
  

  return (
    <div className={classes.BasicInformationStyles}>
<Grid container>
<section className={classes.container}>
<Grid item xs={12} className={classes.detailsContainer}>
  <Grid container className={classes.containerWrapper}>

  <Grid item xs={12}>
              <section className={classes.avatarContainer}>
                <div className={classes.avatarWrapper}>
                  <div className={classes.avatar}>
                    <img
                      src={formik.values.passengerProfileImage?formik.values.passengerProfileImage:"/assets/images/user/avatar.png"}
                      alt="avatar"
                      className={classes.img}
                      style={{ objectFit: "cover" }}
                    />
                    <section
                      {...getRootProps()}
                      onClick={open}
                      className={classes.editIcon}
                    >
                      <input {...getInputProps()} />
                      <CameraAltOutlinedIcon />
                    </section>
                    
                {formik.errors.passengerProfileImage && formik.touched.passengerProfileImage && (
                <Typography color="error" variant="caption">
                {formik.errors.passengerProfileImage}
                </Typography>
                )}
                  </div>
                </div>
              </section>
    </Grid>

 <Grid item xs={12} md={6} lg={6} xl={6}>

    <Grid container>

<Grid
  item
  xs={12}
  md={12}
  lg={12}
  xl={12}
  className={classes.textFieldWrapper}
>
  <TextField
    inputProps={{
    form: {
          autocomplete: 'off',
        },
    }}
    id="firstName"
    label={t({ id: "driver.field.firstName" })}
    value={formik?.values?.firstName}
    defaultValue={formik?.values?.firstName}
    onChange={formik.handleChange}
    error={
      formik?.errors?.firstName &&
      formik?.touched?.firstName
    }
    helperText={
      formik?.errors?.firstName &&
      formik?.touched?.firstName &&
      formik?.errors?.firstName
    }
    fullWidth
    variant="outlined"
    size="small"
  ></TextField>
</Grid>

    <Grid
      item
      xs={12}
      md={12}
      lg={12}
      xl={12}
      className={classes.textFieldWrapper}
    >
      <TextField
        inputProps={{
        form: {
              autocomplete: 'off',
            },
        }}
        name="lastName"
        id="lastName"
        label={t({ id: "driver.field.lastName" })}
        value={formik?.values?.lastName}
        defaultValue={formik?.values?.lastName}
        onChange={formik?.handleChange}
        error={
          formik?.errors?.lastName &&
          formik?.touched?.lastName
        }
        helperText={
          formik?.errors?.lastName &&
          formik?.touched?.lastName &&
          formik?.errors?.lastName
        }
        fullWidth
        variant="outlined"
        size="small"
      ></TextField>
    </Grid>

      <Grid item md={12} lg={12} xl={12}>
        <Grid container>
          <Grid
            item
            md={4}
            lg={4}
            xl={4}
            className={classes.textFieldWrapper}
          >
            <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
              name="countryCode"
              id="countryCode"
              label={t({ id: "driver.field.countryCode" })}
              value={formik?.values?.countryCode}
              defaultValue={formik?.values?.countryCode}
              onChange={formik?.handleChange}
              select
              error={
                formik?.errors?.countryCode &&
                formik?.touched?.countryCode
              }
              helperText={
                formik?.errors?.countryCode &&
                formik?.touched?.countryCode &&
                formik?.errors?.countryCode
              }
              fullWidth
              variant="outlined"
              size="small"
            >
              {countryCodeData.map((country) => (
                <MenuItem
                  key={country.code}
                  value={country.dial_code}
                >
                  {`${country.code} (${country.dial_code})`}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid
            item
            md={8}
            lg={8}
            xl={8}
            className={classes.textFieldWrapper}
          >
            <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
              name="mobile"
              id="mobile"
              label={t({ id: "driver.field.mobile" })}
              value={formik?.values?.mobile}
              defaultValue={formik?.values?.mobile}
              onChange={formik?.handleChange}
              error={
                formik?.errors?.mobile && formik?.touched?.mobile
              }
              helperText={
                formik?.errors?.mobile &&
                formik?.touched?.mobile &&
                formik?.errors?.mobile
              }
              fullWidth
              variant="outlined"
              size="small"
            ></TextField>
          </Grid>
        </Grid>
      </Grid>

      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        xl={12}
        className={classes.textFieldWrapper}
      >
        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
          name="email"
          id="email"
          label={t({ id: "driver.field.email" })}
          value={formik?.values?.email}
          onChange={formik?.handleChange}
          error={formik?.errors?.email && formik?.touched?.email}
          helperText={
            formik?.errors?.email &&
            formik?.touched?.email &&
            formik?.errors?.email
          }
          fullWidth
          variant="outlined"
          size="small"
        />
      </Grid>

    </Grid>
  </Grid>

  <Grid item xs={12} md={6} lg={6} xl={6}>

      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        xl={12}
        className={classes.textFieldWrapper}
      >
        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
          name="gender"
          id="gender"
          select
          label={t({ id: "driver.field.gender" })}
          value={formik?.values?.gender || ""}
          onChange={formik?.handleChange}
          error={formik?.errors?.gender && formik?.touched?.gender}
          helperText={
            formik?.errors?.gender &&
            formik?.touched?.gender &&
            formik?.errors?.gender
          }
          fullWidth
          variant="outlined"
          size="small"
        >
          {["male", "female"].map((option) => (
            <MenuItem key={option} value={option}>
              {option === "male" ? t({ id: "driver.field.male" }) : t({ id: "driver.field.female" })}
            </MenuItem>
          ))}
        </TextField>
      </Grid>

      <Grid
        item
        xs={12}
        md={12}
        lg={12}
        xl={12}
        className={classes.textFieldWrapper}
      >
        <TextField
                          inputProps={{
                          form: {
                                autocomplete: 'off',
                              },
                          }}
          name="country"
          id="country"
          select
          label={t({ id: "driver.field.country" })}
          value={formik?.values?.country}
          onChange={formik?.handleChange}
          error={
            formik?.errors?.country && formik?.touched?.country
          }
          helperText={
            formik?.errors?.country &&
            formik?.touched?.country &&
            formik?.errors?.country
          }
          fullWidth
          variant="outlined"
          size="small"
        >
      {countryCodeData.map((country) => (
      <MenuItem
        key={country.code}
        value={country.name}
      >
        {`${country.code} (${country.name})`}
      </MenuItem>
      ))}
        </TextField>
      </Grid>


{/* bank account number */}
    {/* <Grid
      item
      xs={12}
      md={12}
      lg={12}
      xl={12}
      className={classes.textFieldWrapper}
    >
      <TextField
                          inputProps={{
                          form: {
                            autocomplete: "new-password",
                              },
                          }}
        name="bankAccountNumber"
        id="bankAccountNumber"
        label="Bank Account Number"
        value={formik?.values?.bankAccountNumber}
        onChange={formik?.handleChange}
        error={
          formik?.errors?.bankAccountNumber &&
          formik?.touched?.bankAccountNumber
        }
        helperText={
          formik?.errors?.bankAccountNumber &&
          formik?.touched?.bankAccountNumber &&
          formik?.errors?.bankAccountNumber
        }
        fullWidth
        variant="outlined"
        size="small"
      />
    </Grid> */}

  </Grid>
</Grid>
</Grid>
</section>
</Grid>
    </div>
  );
};

export default BasicInformation;
